import { configureStore } from '@reduxjs/toolkit';

import { setUnauthorizedHandler } from '../api/client';
import authReducer, { logout } from './slices/authSlice';
import { bhajanCategoryReducer, bhajanReducer } from './slices/bhajanSlice';
import { galleryCategoryReducer, galleryReducer } from './slices/gallerySlice';
import { publicationCategoryReducer, publicationReducer } from './slices/publicationSlice';
import { videoCategoryReducer, videoReducer } from './slices/videoSlice';
import { newsEventReducer } from './slices/newsEventSlice';
import { festivalReducer } from './slices/festivalSlice';
import { advertisementReducer } from './slices/advertisementSlice';
import { shareKnowledgeReducer } from './slices/shareKnowledgeSlice';
import { notificationReducer } from './slices/notificationSlice';
import { userReducer } from './slices/userSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    bhajans: bhajanReducer,
    bhajanCategories: bhajanCategoryReducer,
    publications: publicationReducer,
    publicationCategories: publicationCategoryReducer,
    gallery: galleryReducer,
    galleryCategories: galleryCategoryReducer,
    videos: videoReducer,
    videoCategories: videoCategoryReducer,
    newsEvents: newsEventReducer,
    festivals: festivalReducer,
    advertisements: advertisementReducer,
    shareKnowledge: shareKnowledgeReducer,
    notifications: notificationReducer,
    users: userReducer,
  },
});

setUnauthorizedHandler(() => store.dispatch(logout()));
